module.exports = __webpack_public_path__ + "static/media/discord.ed2461c6.png";